import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['companySelect', 'companyIdField', 'reportsList']

  declare readonly companySelectTarget: HTMLSelectElement
  declare readonly companyIdFieldTarget: HTMLInputElement
  declare readonly reportsListTarget: HTMLElement

  companyChange(): void {
    this.reportsListTarget.innerHTML = ''
    this.companyIdFieldTarget.value = this.companySelectTarget.value
  }
}
